export const painPoints = [
  {
    emoji: '🧭',
    title: "You don't know where to start",
    desc: 'The spinal healing process looks confusing. This method organizes everything: first the SOS decompression, then the hip unlocking, then the core shielding and maintenance.',
  },
  {
    emoji: '🔤',
    title: 'You get stuck with exercise selection',
    desc: 'You learn the guided way, recognizing which movements help disc space and which ones are too risky. No more guessing.',
  },
  {
    emoji: '🧩',
    title: "You can't build a complete protocol",
    desc: 'You learn the complete 360° structure to build routines that actually heal the spine instead of just masking the symptoms.',
  },
  {
    emoji: '🎯',
    title: 'You fear a relapse',
    desc: 'Guessing with your spine is dangerous. A clear progression framework is what keeps your discs safe until they can handle daily loads again.',
  },
];
